import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class ClaimCredits5000 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      balance: 0,
      errorMessage: '',
      successMessage: '',
    };
  }

  componentDidMount() {
    const { state } = this.props.location;
    if (state && state.email && state.balance !== undefined) {
      this.setState({ email: state.email, balance: state.balance });
    } else {
      this.fetchUserData();
    }
  }

  fetchUserData = async () => {
    try {
      const response = await fetch('/user-details', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        this.setState({ email: data.email, balance: data.balance });
      } else {
        console.error('Failed to fetch user details');
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { balance, email } = this.state;
    const newBalance = balance + 5000;

    try {
      const updateResponse = await fetch('/update-balance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newBalance }),
      });

      if (!updateResponse.ok) {
        throw new Error('Failed to update balance in the database');
      }

      this.setState({
        successMessage: '🎉 You have claimed your 5000 credits successfully!',
        errorMessage: '',
        balance: newBalance,
      });

      // 🔹 Redirect to homepage after 1.5 seconds
      setTimeout(() => {
        this.handleLogout();
      }, 1500);

    } catch (error) {
      console.error('Error:', error);
      this.setState({ errorMessage: 'An error occurred!', successMessage: '' });
    }
  };

  handleLogout = () => {
    // Redirect to homepage
    this.props.history.push('/');
  };

  render() {
    const { email, balance, errorMessage, successMessage } = this.state;

    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className="logo" src={logo} alt="Logo" />
          <div className="user-details mt-2">
            <span>Email: {email || 'Loading...'}</span> | <span>Balance: ${balance.toFixed(2)}</span>
          </div>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="amount">Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        name="amount"
                        id="amount"
                        value={5000}
                        readOnly
                      />
                    </div>

                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}

                    <button type="submit" className="btn btn-dark">Claim Reward</button>
                  </form>
                  <br />
                  <button
                    onClick={this.handleLogout}
                    style={{ marginTop: '20px', padding: '10px', cursor: 'pointer' }}
                  >
                    Logout
                  </button>
                  <div>Powered by</div>
                  <img className="logo2" src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ClaimCredits5000);
